import React, {useState} from "react";
import { ArrowRightIcon, TrophyIcon, ChartBarIcon, UserIcon, CheckIcon, CheckCircleIcon, ChatBubbleLeftIcon, TruckIcon, StarIcon, WrenchIcon, UsersIcon } from '@heroicons/react/24/solid';
import {Link} from 'gatsby';
import Layout from '../components/Layout';
import numeral from 'numeral';
import { XMarkIcon, ArrowDownTrayIcon } from '@heroicons/react/24/solid';
import Seo from '../components/Seo';

const IndexPage = ({ pageContext: { collections, collection, title } }) => {


  const [sort, setSort] = useState('alpha');

  const [showCollections, setShowCollections] = useState(false);

  const [multiplier, setMultiplier] = useState(2);

  const downloadPriceList = () => {
    var frame = window.frames['iframe'].contentWindow;

    frame.getDocumentById('download-link').click();
  }

  const sortByTitle = (a, b) => {

    if (a.product == null || b.product == null) {
      return 0;
    }

    return a.product.title.localeCompare(b.product.title);
  }
  

  const sortByPriceAsc = (a, b) => {
    if (a.product == null || b.product == null) {
      return 0;
    }

    if (a.product.min_price < b.product.min_price) {
      return -1;
    }

    if (a.product.min_price > b.product.min_price) {
      return 1;
    }

    return 0;
  }

  const sortByPriceDesc = (a, b) => {
    if (a.product == null || b.product == null) {
      return 0;
    }

    if (a.product.min_price < b.product.min_price) {
      return 1;
    }

    if (a.product.min_price > b.product.min_price) {
      return -1;
    }

    return 0;
  }

  var sortFn = sortByTitle;

  switch(sort) {
    case 'alpha':
      sortFn = sortByTitle;
      break;
    case 'price_asc':
      sortFn = sortByPriceAsc;
      break;
    case 'price_desc':
      sortFn = sortByPriceDesc;
      break;
    default:
      sortFn = sortByTitle;
  }

  const products = collection.products.sort(sortFn);

  const collectionSlug = collection.slug=='frontpage'?'most-popular':collection.slug;

  return (
    <Layout className="as">
      <section className="container mx-auto">
      <div className="md:grid md:grid-cols-5">
      <div className={`${showCollections?'block':'hidden'} md:block fixed md:relative top-0 px-10 py-10 sm:py-0 sm:px-0 left-0 overflow-y-auto w-full md:w-auto h-full md:h-auto bg-white md:bg-transparent`}>
        <button className="absolute right-5 top-5 md:hidden" onClick={() => setShowCollections(false)}><XMarkIcon className="w-10 h-10 text-black"/></button>
        <h3 className="font-bold text-sm text-rose-600 md:text-black">Browse by Collections</h3>
        <ul>
          {
            collections.map(collection => {

              const slug = collection.slug=='frontpage'?'most-popular':collection.slug;
              const name = collection.slug=='frontpage'?'Most Popular':collection.name;

              return <li key={`collection-${slug}`}>
                <Link to={`/collections/${slug}`} className="font-basic text-xl md:text-sm hover:text-indigo-600">{name}</Link>
              </li>
            })
          }
        </ul>
      </div>
      <div className="col-span-4 pb-20 px-4 md:px-0">
        <div className="md:flex justify-between items-start md:items-center mb-4 md:mb-0">
          <div>
            <h1 className="text-3xl font-bold mb-3">{title}</h1>
            <p className="text-sm font-basic mb-5">{collection.products.length} products &middot; <a href="#download-price-list" className="text-indigo-600 hover:text-indigo-700">Price List</a></p>
          </div>
          <div>
            <select className="w-full md:w-auto md:mt-0 border py-2 px-2 font-basic text-sm rounded-sm" value={sort} onChange={(e) => setSort(e.target.value)}>
              <option value="alpha">Sort Alphabetically</option>
              <option value="price_asc">Lowest Price to Highest Price</option>
              <option value="price_desc">Highest Price to Lowest Price</option>
            </select>
          </div>
        </div>
        <div className="md:hidden mb-8">
          <button className="text-sm text-indigo-600" onClick={() => setShowCollections(true)}>View Product Collections</button>
        </div>
        <div className="sm: grid sm:grid-cols-2 md:grid-cols-3 gap-4 ">
        {
          products.map(({product}) => {

            if (product == null) {
              return null;
            }

            return <div key={`product-${product.id}`} className="border p-2 rounded-sm">
              <Link to={`/collections/${collectionSlug}/products/${product.handle}`}><img src={product.image.src} className="aspect-square"/></Link>
              <Link to={`/collections/${collectionSlug}/products/${product.handle}`} className="hover:text-indigo-600 block text-gray-800 text-sm">{product.title}</Link>
              {
                (product.variants.length>1)?<span className="text-sm font-basic text-green-600 font-bold">{numeral(product.min_price).format('$0,0.00')} - {numeral(product.max_price).format('$0,0.00')}</span>:<span className="text-md font-basic text-green-600 font-bold">{numeral(product.min_price).format('$0,0.00')}</span>
              }
            </div>})
        }
        </div>
      </div>
      </div>
      
      </section>
      <div className="bg-black py-10 md:py-20" id="download-price-list">
        <div className="container mx-auto px-4 lg:px-0">
        <div className="md:grid md:grid-cols-2">
        <div>
          <h3 className="text-white text-2xl font-bold mb-2">Download this product collection's list</h3>
          <div className="mb-2">
            <label className="text-gray-100 mr-1">Price Multiplier:</label>
            <span className="text-white font-bold">{numeral(multiplier).format('0.0')}x</span>
          </div>
          <p className="text-gray-100 text-sm">Move the slider to simulate your prices + profit margins based on how much each product costs.</p>
          <input className="mt-5 mb-5 disabled:opacity-25 w-full thumb-rose-600 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer text-rose-600" type="range" step=".1" min="1.1" max="3" value={multiplier} onChange={(e) => setMultiplier(e.target.value)}/>
          <div className="relative">
          <button style={{position:'relative'}} className="flex items-center hover:bg-rose-500 w-full sm:w-64 justify-center bg-rose-600 text-white font-bold px-4 sm:px-6 py-2 rounded-md relative">
            <ArrowDownTrayIcon className="mr-2 w-5 h-5 inline-block"/>Download Price List
            <iframe className="absolute top-0 left-0 w-full h-full block" name="iframe" id="iframe" src={`https://${process.env.API_DOMAIN}/download-button?collection_id=${collection.id}&multiplier=${multiplier}&filename=${collection.slug}-${multiplier}x.csv`}></iframe>

          </button>
          </div>
        </div>
        </div>
        </div>
      </div>
    </Layout>
  )
}
 
export default IndexPage

export const Head = ({pageContext}) => {

  const data = {url: `https://www.dropshipbeauty.app/collections/${pageContext.slug}` };

  if (pageContext.collection && pageContext.collection.products && pageContext.collection.products.length > 0) {
     //console.log(pageContext.collection.products);

     let product = pageContext.collection.products.find(record => record.product!=null&&record.product.image!=null);

     if (product) {
      //console.log(product);
      data.image =  product.product.image.src;
     }
  }

  return <Seo title={pageContext.title} data={data}/>
}
